// store/selectors/user.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SitesState, SiteState,TypeState,TypesState } from '../reducers/site.reducer';

export const selectSiteState = createFeatureSelector<SiteState>('site');
export const selectSitesState = createFeatureSelector<SitesState>('sites');
export const selectTypeState = createFeatureSelector<TypeState>('typeSite');
export const selectTypesState = createFeatureSelector<TypesState>('typesSite');

export const selectSites = createSelector(
  selectSitesState,
  (state) => state.sites
); 
export const selectSite = createSelector(
  selectSiteState,
  (state) => state.site
); 
export const selectTypes = createSelector(
  selectTypesState,
  (state) => state.typesSite
); 
export const selectType = createSelector(
  selectTypeState,
  (state) => state.typeSite
); 